export default "__VITE_ASSET__DnZoBSeS__"